import React from 'react';
import classes from './SimpleTableRow.module.css';
import { SimpleTableCell } from '../SimpleTableCell/SimpleTableCell';
import { ColumnType } from '../types';

import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../../hooks/useTranslations';

type TableRowProps<T> = {
  row: T;
  columns: ColumnType<T>[];
  index: number;
  style?: React.CSSProperties;
  cellStyle?: React.CSSProperties;
  isDownloading?: boolean;
};

const SimpleTableRow = <T,>({
  row,
  columns,
  index,
  style = {},
  cellStyle = {},
  isDownloading = false,
}: TableRowProps<T>) => {
  // there are rows which have info about the sales order, to know if it can be checked in from the Order Summary modal
  const rowData: any = row;
  const { translations } = useTranslation();
  const navigate = useNavigate();
  return (
    <tr className={index % 2 === 0 ? classes.lightRow : classes.darkRow} style={style}>
      {columns.map((column, _index) => (
        <SimpleTableCell align={column.align ?? 'left'} key={_index} style={cellStyle}>
          {column.renderer(row, index)}
        </SimpleTableCell>
      ))}
      {!isDownloading && !!!rowData?.hasWorkOrder && !!rowData.isDiagnostic && (
        <td
          style={{
            ...cellStyle,
            padding: 0,
          }}
          onClick={() =>
            navigate(
              `/web/schedule?selectedTab=check-in&accountNumber=${rowData.accountNumber}&salesOrderId=${rowData.salesOrderId}&salesOrderItemId=${rowData.salesOrderItemId}`
            )
          }
        >
          <div className={classes.actionButton}> {translations('check.in')}</div>
        </td>
      )}
    </tr>
  );
};

export { SimpleTableRow };
